import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getParametros } from 'services/servicioGet';
import { TipoParametro } from 'utils/models/types';

interface ParametrosState {
  parametros: TipoParametro[];
  loadingParametros: boolean;
  errorParametros: string | null;
}

// Estado inicial del slice
const initialState: ParametrosState = {
  parametros: [],
  loadingParametros: false,
  errorParametros: null,
};

// Thunk para obtener los tipos de elenco
export const fetchParametros = createAsyncThunk<TipoParametro[], void, { rejectValue: string }>(
  'fetchParametros',
  async (_, { rejectWithValue }) => {
    try {
      const response = await getParametros();
      return response;
    } catch (error: unknown) {
      return rejectWithValue(error instanceof Error ? error.message : String(error));
    }
  }
);

// Slice de parámetros
const parametrosSlice = createSlice({
  name: 'parametros',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(fetchParametros.pending, state => {
        state.loadingParametros = true;
        state.errorParametros = null;
      })
      .addCase(fetchParametros.fulfilled, (state, action) => {
        state.parametros = action.payload;
        state.loadingParametros = false;
      })
      .addCase(fetchParametros.rejected, (state, action) => {
        state.loadingParametros = false;
        state.errorParametros = action.payload as string;
      });
  },
});

export default parametrosSlice.reducer;
